import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { APIResponse } from "~models";
import {getUrlCurrentSession, handleErrorCallAPI} from "~utils/index";
import { saveAs } from "file-saver";

async function connectGet<T>(url: string, params: any) {
  const params_: any = {};
  for (let k in params) {
    if (params[k] === "") {
      continue;
    }
    params_[k] = params[k];
  }

  return new Promise<APIResponse<T> | null>((resolve) => {
    axios
      .get(url, { params: params_ })
      .then((res) => {
        resolve(new APIResponse<T>(res));
      })
      .catch((error: AxiosError) => {
        console.log(error.response);
        const urlCurrent = window.location.pathname + window.location.search;
        const response = error.response;
        const errApi = response?.data.error;
        // check url exist
        let urlCurrentSession = getUrlCurrentSession(urlCurrent)
        if (response) {
          if (response?.status == 401 || response?.status == 403) {
            if(!urlCurrentSession){
              handleErrorCallAPI(errApi.message, errApi.code, urlCurrent);
            }
            return;
          }
          resolve(new APIResponse<T>(response));
        } else {
          resolve(null);
        }
      });
  });
}

async function connectPost<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig | undefined
) {
  return new Promise<APIResponse<T> | null>((resolve) => {
    axios
      .post(url, data, config)
      .then((res) => {
        resolve(new APIResponse<T>(res));
      })
      .catch((error: AxiosError) => {
        console.log(error.response);
        const response = error.response;
        const urlCurrent = window.location.pathname + window.location.search;
        const errApi = response?.data.error;
        // check url exist
        let urlCurrentSession = getUrlCurrentSession(urlCurrent)
        if (response) {
          if (response?.status == 401 || response?.status == 403) {
            if(!urlCurrentSession){
              handleErrorCallAPI(errApi.message, errApi.code, urlCurrent);
            }
            return;
          }
          resolve(new APIResponse<T>(response));
        } else {
          resolve(null);
        }
      });
  });
}

async function connectPut<T>(url: string, data: any) {
  return new Promise<APIResponse<T> | null>((resolve) => {
    axios
      .put(url, data)
      .then((res) => {
        resolve(new APIResponse<T>(res));
      })
      .catch((error: AxiosError) => {
        console.log(error.response);
        const response = error.response;
        const urlCurrent = window.location.pathname + window.location.search;
        // check url exist
        let urlCurrentSession = getUrlCurrentSession(urlCurrent)
        const errApi = response?.data.error;
        if (response) {
          if (response?.status == 401 || response?.status == 403) {
            if(!urlCurrentSession){
              handleErrorCallAPI(errApi.message, errApi.code, urlCurrent);
            }
            return;
          }
          resolve(new APIResponse<T>(response));
        } else {
          resolve(null);
        }
      });
  });
}

async function connectDel<T>(url: string, data: any) {
  return new Promise<APIResponse<T> | null>((resolve) => {
    axios
      .request({
        method: "delete",
        url: url,
        data: data,
      })
      // axios
      //   .delete(url, data)
      .then((res) => {
        resolve(new APIResponse<T>(res));
      })
      .catch((error: AxiosError) => {
        console.log(error.response);
        const response = error.response;
        const urlCurrent = window.location.pathname + window.location.search;
        const errApi = response?.data.error;
        // check url exist
        let urlCurrentSession = getUrlCurrentSession(urlCurrent)
        if (response) {
          if (response?.status == 401 || response?.status == 403) {
            if(!urlCurrentSession){
              handleErrorCallAPI(errApi.message, errApi.code, urlCurrent);
            }
            return;
          }
          resolve(new APIResponse<T>(response));
        } else {
          resolve(null);
        }
      });
  });
}

async function connectDownload(url: string, data: any) {
  return new Promise<boolean>((resolve) => {
    axios
      .post(url, data, { responseType: "blob" })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: res.data.type,
        });
        const contentDisposition = res.headers["content-disposition"];
        let fileName = getFileName(contentDisposition);
        saveAs(blob, fileName);
        resolve(true);
      })
      .catch(async (reason: AxiosError) => {
        resolve(false);
      });
  });
}

function getFileName(contentDisposition: string) {
  //Supports Japanese file names
  //contentDisposition： attachment; filename="æ.csv"; filename*=utf-8''請求保証.csv
  if (
    contentDisposition.indexOf("filename*=utf-8") !== -1 ||
    contentDisposition.indexOf("filename*=UTF-8") !== -1
  ) {
    let fileName = contentDisposition.substring(
      contentDisposition.indexOf("''") + 2,
      contentDisposition.length
    );
    //When decoded, the space becomes "+", so replace it with a space.
    fileName = decodeURI(fileName).replace(/\+/g, " ");
    return fileName;
  }

  //contentDisposition： attachment; filename="export_journal_2_20210707154330.csv"
  const startIndex = contentDisposition.indexOf('filename="') + 10;
  const endIndex = contentDisposition.length - 1;
  return contentDisposition.substring(startIndex, endIndex);
}

function connectDownloadWithErrors(url: string, data: any) {
  return axios
    .post(url, data, { responseType: "blob" })
    .then(res => res)
    .catch(error => error.response);
}

export { connectGet, connectPost, connectPut, connectDel, connectDownload, connectDownloadWithErrors };
